import React, { FunctionComponent, useMemo } from 'react';

import { Campaign } from '@shared/types/mylounge';
import { TWENTY_FOUR_HOURS_IN_MILLISECONDS } from '@client/config/constants';
import { SpecialCountdown } from '@client/components/shared/Shared';
import { TimeLeft } from '@client/components/shared/timeLeft';

import Discount from './discount';
import { CategorySubline } from './category-subline';
import * as S from './campaign-info.styles';

interface Props {
    campaign: Campaign;
    categorySubline: string[];
}

export const CampaignInfo: FunctionComponent<Props> = ({ campaign, categorySubline }) => {
    const thresholdForSpecialTimer = Date.now() + TWENTY_FOUR_HOURS_IN_MILLISECONDS;

    const dateEnd = useMemo(() => new Date(campaign.endsAt).getTime(), [campaign.endsAt]);
    const isSpecialTimer =
        campaign.options && campaign.options.specialTimer && dateEnd <= thresholdForSpecialTimer;

    return (
        <S.Container>
            <S.Wrapper>
                {isSpecialTimer ? (
                    <SpecialCountdown dateTill={dateEnd} />
                ) : (
                    <S.RegularContainer>
                        <CategorySubline categorySubline={categorySubline} />
                        <S.RegularTextContainer>
                            <TimeLeft dateTill={dateEnd} />
                            <Discount campaign={campaign} />
                        </S.RegularTextContainer>
                    </S.RegularContainer>
                )}
            </S.Wrapper>
        </S.Container>
    );
};

export default CampaignInfo;
